module.exports = __webpack_public_path__ + "fonts/source-sans-pro-v21-latin-regular.33b6cf71.eot";